export function deleteUndefined(obj) {
    return Object.keys(obj).reduce(function (acc, key) {
        if (obj[key] !== undefined)
            acc[key] = obj[key];
        return acc;
    }, {});
}
export function flip(data) {
    var res = {};
    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
        var key = _a[_i];
        var value = data[key];
        if (value !== undefined) {
            res[value] = key;
        }
    }
    return res;
}
export function mapIfDefined(t, f) {
    return t === undefined || t === null ? undefined : f(t);
}
//# sourceMappingURL=utils.js.map